export interface ServiceLocation {
  slug: string
  name: string
  county: string
  headline: string
  intro: string
  localDetails: string[]
  seoTitle: string
  seoDescription: string
}

export const serviceLocations: ServiceLocation[] = [
  {
    slug: "tampa",
    name: "Tampa",
    county: "Hillsborough County",
    headline: "Electrician in Tampa, FL",
    intro:
      "From Seminole Heights bungalows to South Tampa estates and Ybor City commercial spaces, Third Gen Electric has been wiring Tampa homes and businesses for over 30 years. We're licensed, local, and know the neighborhoods.",
    localDetails: [
      "Panel upgrades for Tampa's aging mid-century homes",
      "Commercial electrical for Ybor City and downtown buildouts",
      "EV charger installation across South Tampa and Hyde Park",
      "24/7 emergency electrical service throughout Tampa",
    ],
    seoTitle: "Electrician in Tampa, FL — Third Gen Electric",
    seoDescription:
      "Licensed electricians serving Tampa, FL. Panel upgrades, EV charger installation, residential wiring, and commercial electrical. Family-owned, 30+ years of experience.",
  },
  {
    slug: "brandon",
    name: "Brandon",
    county: "Hillsborough County",
    headline: "Electrician in Brandon, FL",
    intro:
      "Brandon's rapid suburban growth means a lot of homes built in the 1980s and 1990s that are now due for panel upgrades, rewiring, and modern safety additions. Third Gen Electric is the area's trusted electrical contractor.",
    localDetails: [
      "200-amp panel upgrades for older Brandon subdivisions",
      "AFCI and GFCI retrofits for 1980s–1990s construction",
      "EV charger installation for Brandon's growing EV community",
      "Fast response times — we're based right here in the area",
    ],
    seoTitle: "Electrician in Brandon, FL — Third Gen Electric",
    seoDescription:
      "Licensed electricians serving Brandon, FL. Panel upgrades, rewiring, EV charger installation, and residential electrical work. Family-owned with 30+ years of experience.",
  },
  {
    slug: "st-petersburg",
    name: "St. Petersburg",
    county: "Pinellas County",
    headline: "Electrician in St. Petersburg, FL",
    intro:
      "St. Petersburg's mix of historic bungalows, downtown condos, and commercial corridors keeps us busy year-round. Whether you're renovating a 1950s Craftsman or wiring a new business on Central Avenue, Third Gen Electric handles it right.",
    localDetails: [
      "Knob-and-tube and aluminum wiring replacement in historic St. Pete homes",
      "Panel upgrades and service entrance work for older neighborhoods",
      "Commercial electrical for the Grand Central and EDGE districts",
      "Whole-home generator installation for storm preparedness",
    ],
    seoTitle: "Electrician in St. Petersburg, FL — Third Gen Electric",
    seoDescription:
      "Licensed electricians serving St. Petersburg, FL. Rewiring, panel upgrades, commercial electrical, and generator installation. Family-owned, 30+ years of experience.",
  },
  {
    slug: "dover",
    name: "Dover",
    county: "Hillsborough County",
    headline: "Electrician in Dover, FL",
    intro:
      "Dover's rural character and mix of older farmhouses and newer residential developments means electrical needs that vary widely. Third Gen Electric serves Dover properties of all sizes — from basic service calls to full property rewires.",
    localDetails: [
      "Service upgrades for older rural properties and farmhouses",
      "Whole-home rewiring for aging Dover residences",
      "Generator and transfer switch installation for outage preparedness",
      "New construction wiring as Dover continues to develop",
    ],
    seoTitle: "Electrician in Dover, FL — Third Gen Electric",
    seoDescription:
      "Licensed electricians serving Dover, FL. Service upgrades, rewiring, generator installation, and residential electrical. Family-owned, serving Hillsborough County.",
  },
  {
    slug: "apollo-beach",
    name: "Apollo Beach",
    county: "Hillsborough County",
    headline: "Electrician in Apollo Beach, FL",
    intro:
      "Apollo Beach's waterfront homes, newer construction, and outdoor lifestyle create unique electrical demands. Third Gen Electric is experienced with coastal properties — from boat dock wiring to whole-home generators that keep you powered through storm season.",
    localDetails: [
      "Boat dock and marine electrical installation and repair",
      "Outdoor and landscape lighting for waterfront properties",
      "Standby generator installation for hurricane preparedness",
      "Level 2 EV charger installation for Apollo Beach's newer homes",
    ],
    seoTitle: "Electrician in Apollo Beach, FL — Third Gen Electric",
    seoDescription:
      "Licensed electricians serving Apollo Beach, FL. Boat dock wiring, generator installation, EV chargers, and waterfront home electrical. Family-owned, Hillsborough County.",
  },
  {
    slug: "hillsborough",
    name: "Hillsborough County",
    county: "Hillsborough County",
    headline: "Electrician Serving Hillsborough County, FL",
    intro:
      "Third Gen Electric covers all of Hillsborough County — Tampa, Brandon, Riverview, Valrico, Plant City, Sun City Center, and every community in between. One licensed contractor for all your residential and commercial electrical needs across the county.",
    localDetails: [
      "Serving all Hillsborough County cities and unincorporated areas",
      "New construction wiring for the county's booming developments",
      "Residential and commercial electrical across the full housing stock",
      "County permit and inspection coordination on every job",
    ],
    seoTitle: "Electrician in Hillsborough County, FL — Third Gen Electric",
    seoDescription:
      "Licensed electricians serving all of Hillsborough County, FL. Residential and commercial electrical, panel upgrades, EV chargers, and generators. Family-owned, 30+ years.",
  },
  {
    slug: "pinellas",
    name: "Pinellas County",
    county: "Pinellas County",
    headline: "Electrician Serving Pinellas County, FL",
    intro:
      "Pinellas County has one of Florida's oldest and densest housing stocks, with thousands of homes that need panel upgrades, rewiring, and safety modernization. Third Gen Electric serves St. Petersburg, Clearwater, Largo, Dunedin, and all of Pinellas.",
    localDetails: [
      "Aluminum wiring remediation for Pinellas County's older homes",
      "Panel upgrades for homes built in the 1950s through 1980s",
      "Commercial electrical for Clearwater and St. Pete business corridors",
      "Storm and surge damage repair and generator installation",
    ],
    seoTitle: "Electrician in Pinellas County, FL — Third Gen Electric",
    seoDescription:
      "Licensed electricians serving Pinellas County, FL. Panel upgrades, rewiring, commercial electrical, and generator installation. Serving St. Pete, Clearwater, Largo, and more.",
  },
  {
    slug: "pasco",
    name: "Pasco County",
    county: "Pasco County",
    headline: "Electrician Serving Pasco County, FL",
    intro:
      "Pasco County is one of the fastest-growing areas in Florida, with new subdivisions, commercial development, and infrastructure projects rolling out across Wesley Chapel, Land O'Lakes, Lutz, and New Port Richey. Third Gen Electric keeps pace with the build.",
    localDetails: [
      "New construction wiring for Pasco County's booming residential developments",
      "EV infrastructure and charging station installation for new communities",
      "Panel upgrades and service work for older New Port Richey and Zephyrhills properties",
      "Commercial electrical for Wesley Chapel's expanding commercial corridor",
    ],
    seoTitle: "Electrician in Pasco County, FL — Third Gen Electric",
    seoDescription:
      "Licensed electricians serving Pasco County, FL. New construction wiring, panel upgrades, EV chargers, and commercial electrical. Serving Wesley Chapel, Land O'Lakes, and more.",
  },
]

export function getLocationBySlug(slug: string): ServiceLocation | undefined {
  return serviceLocations.find((loc) => loc.slug === slug)
}
